import sileo from 'sileo';

const InterviewQuestionInterval = new sileo.Model('bposeats', 'interview-question-interval');
const Transcription = new sileo.Model('bposeats', 'applicant-transcription');


const actions = {
    fetchInterviewQuestionInterval() {
        const DEFAULT_PK = 1;
        return InterviewQuestionInterval.objects.get(DEFAULT_PK);
    },

    fetchApplicantTranscription(context, pk) {
        return Transcription.objects.get(pk);
    },
};


export default {
    namespaced: true,
    actions
};
